module.exports = __webpack_public_path__ + "static/media/tim-cartoon.00a8aa77.png";